/* =====================================================================
 * queryKeys — shared React Query key factory.
 *
 * Hoisted in P11-4g-pass2 so B2C and B2B tenants share the exact same
 * cache keys for workspace / billing / plugins / calendar / drive data.
 * Hosts still own the `QueryClient` instance; this module only exposes
 * the pure key shapes which are safe to reference from any layer.
 * ===================================================================== */

export const queryKeys = {
  billing: {
    catalog: () => ['billing', 'catalog'] as const,
    status: () => ['billing', 'status'] as const,
  },
  plugins: {
    list: () => ['plugins', 'list'] as const,
  },
  calendar: {
    providers: () => ['calendar', 'providers'] as const,
    events: (rangeKey: string, providersKey: string) =>
      ['calendar', 'events', rangeKey, providersKey] as const,
    guestSuggestions: (query: string, limit: number) =>
      ['calendar', 'guest-suggestions', query || 'recent', limit] as const,
  },
  workspace: {
    stats: (scope: 'personal' | 'team', teamId: string | null) =>
      ['workspace', 'stats', scope, teamId ?? 'none'] as const,
    files: (paramsKey: string) => ['workspace', 'files', paramsKey] as const,
    fileCounts: (itemIdsKey: string) => ['workspace', 'fileCounts', itemIdsKey] as const,
    pageFiles: (itemId: string) => ['workspace', 'pageFiles', itemId] as const,
  },
  drive: {
    list: (provider: 'google_drive' | 'onedrive', folderId: string, pageToken: string) =>
      ['drive', 'list', provider, folderId, pageToken] as const,
    search: (provider: 'google_drive' | 'onedrive', query: string, pageToken: string) =>
      ['drive', 'search', provider, query, pageToken] as const,
  },
};
